import React, { useRef, useEffect } from "react";

interface Tab {
  label: string | (() => string) | React.ReactNode;
  onClick?: () => void;
  component: React.ReactNode;
  isActive?: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  disableActiveTab?: boolean;
  stickyOffset?: number; // new prop
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  disableActiveTab = true,
  stickyOffset = 0, // default to 0 if not provided
}) => {
  const tabRef = useRef<HTMLDivElement>(null);
  const [tabHeight, setTabHeight] = React.useState(0);

  // Determine the active tab index
  const activeTabIndex =
    tabs.length === 1 ? 0 : tabs.findIndex((tab) => tab.isActive) || 0;

  useEffect(() => {
    if (tabRef.current) {
      setTabHeight(tabRef.current.clientHeight);
    }
  }, []);

  return (
    <div>
      <div
        ref={tabRef}
        className="sticky z-10 bg-white border-b my-6 w-full"
        style={{ top: stickyOffset }}
      >
        <div className="w-full bg-white">
          <div className="md:max-w-3xl w-full flex">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => {
                  if (tabs.length > 1 && !tab.isActive && tab.onClick)
                    tab.onClick();
                }}
                className={`flex-1 px-4 py-2 text-center transition-all duration-300 ${
                  index === activeTabIndex
                    ? "border-b-2 border-gray-800 text-black"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
                }`}
                disabled={disableActiveTab && index === activeTabIndex}
              >
                {typeof tab.label === "function"
                  ? tab.label()
                  : React.isValidElement(tab.label)
                    ? tab.label
                    : tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div
        className="min-h-screen overflow-auto"
        style={{ paddingTop: tabHeight }}
      >
        {tabs[activeTabIndex]?.component}
      </div>
    </div>
  );
};

export default TabNavigation;
